import { all, call, put, takeLatest, select } from 'redux-saga/effects'

import co from 'co'
import { util } from 'utils'
import CommonUtil from 'utils/Util'
import { orderTypes, isDeliveryMode, getCurrentCountry } from 'utils/appUtils'
import { getHomePageItems } from 'modules/products/sagas'
import { getCart, updateShipping } from 'modules/basket/sagas'
import { setLastHomePageFetchETA } from 'modules/products/actions'
import {
    locResultURL,
    locPredictionURL,
    // alcoholAuthURL,
    locPlaceIDURL,
    locVerifyResURL,
    storesByLocationURL,
    pickupStoresURL,
} from './urls'
import { api } from '../../network/api'
import { getConfiguration } from '../configuration/actions'
import {
    actions,
    getPlaceDetails_succcess,
    getPlaceDetails_failed,
    getCoordinateDetails_succcess,
    getCoordinateDetails_failed,
    setAlcoholRestriction,
    getAlcoholRestriction,
    verifyPlace_success,
    verifyPlace_failed,
    verifyPlace,
    getStoresByLocationSuccess,
    getStoresByLocationFailed,
    pickupStoresSuccess,
    pickupStoresFailed,
    filterStoreComplete,
    setStoreDetails,
    setAddress,
    getStoreDetailsSuccess,
    getStoreDetailsFailed,
    transferTempToSelected,
} from './actions'
import { saveCateringAddress } from 'modules/catering/actions'

export const getPredictions = co.wrap(function* (_val) {
    try {
        const res = yield api(locPredictionURL, 'POST', { proximity: {}, search_term: _val })
        if (res === null) {
            return yield []
        }
        return yield res.predictions
    } catch (err) {
        return yield err
    }
})

export const detailsFromPlaceId = co.wrap(function* (placeId, mode) {
    try {
        const modURL = locPlaceIDURL.replace('{placeId}', placeId || '')
        const res = yield api(modURL, 'GET')
        return yield util.getCompleteAddress(res.result, mode)
    } catch (err) {
        return yield err
    }
})

function* placeIdWrapper({ payload: placeId, navigate }) {
    try {
        const parsedAddress = yield detailsFromPlaceId(placeId, orderTypes.DELIVERY)
        yield put(getPlaceDetails_succcess(parsedAddress))
        yield put(verifyPlace(parsedAddress)) // validating USPS
        yield* getAllStoresForAddress(parsedAddress)
    } catch (error) {
        console.log(error)
        yield put(getPlaceDetails_failed)
    }
}

export const detailsFromCoordinates = co.wrap(function* (coordinates, mode) {
    try {
        const lat = coordinates.latitude ? coordinates.latitude.toString() : ''
        const lng = coordinates.longitude ? coordinates.longitude.toString() : ''

        const res = yield api(locResultURL, 'POST', { lat, lng })
        return yield util.getCompleteAddress(res.results[0], mode)
    } catch (err) {
        return yield err
    }
})

function* coordinatesWrapper({ payload: coordinates, navigate }) {
    try {
        const parsedAddress = yield detailsFromCoordinates(coordinates, orderTypes.DELIVERY)
        yield put(getCoordinateDetails_succcess(parsedAddress))
        yield put(verifyPlace(parsedAddress)) // validating USPS
        yield* getAllStoresForAddress(parsedAddress)
    } catch (error) {
        yield put(getCoordinateDetails_failed)
    }
}

// eslint-disable-next-line require-yield
function* alcoholRestrictions() {
    // Commenting the Alcohol api call as we don't need this now
    return null
    // try {
    //     const res = yield call(api, alcoholAuthURL, 'POST', {
    //         address: address.nickname,
    //         longitude: address.longitude,
    //         lattitude: address.lattitude,
    //         county: address.county,
    //         city: address.city,
    //         state: address.state,
    //         zipcode: address.zip,
    //     })
    //     yield put(setAlcoholRestriction(res))
    // } catch (error) {
    //     yield put(setAlcoholRestriction(null))
    // }
}

function* validateUSPS({ payload: address }) {
    try {
        const res = yield call(api, locVerifyResURL, 'POST', {
            city: address.city,
            state: address.state,
            street1: address.street,
            street2: '',
            zip: address.zip,
            country: address.country,
        })
        yield put(verifyPlace_success(res))
    } catch (ex) {
        yield put(verifyPlace_failed)
    }
}

export const checkForStores = co.wrap(function* (address) {
    try {
        const request = util.storesByLocationReq(address)
        const res = yield api(storesByLocationURL, 'POST', request)
        return yield res
    } catch (err) {
        return yield err
    }
})

function* getStoresList(action) {
    try {
        const addressInfo = action.payload
        if (addressInfo) {
            yield* getAllStoresForAddress(addressInfo)
        }
    } catch (error) {
        console.log(' getStoresList Error ', error)
    }
}

function* getAllStoresForAddress(address) {
    try {
        const request = util.storesByLocationReq(address)
        const response = yield call(api, storesByLocationURL, 'POST', request, 1)
        if (response && response.stores && response.stores.length > 0) {
            yield put(setLastHomePageFetchETA(null))
            yield put(getStoresByLocationSuccess(response.stores))
            yield put(setStoreDetails(response.stores[0]))
            yield put(setAddress(address))
            yield* triggerAllAPIsForLocationUpdate(address)
        } else {
            yield put(getStoresByLocationFailed())
        }
    } catch (error) {
        yield put(getStoresByLocationFailed())
    }
}

export function* triggerAllAPIsForLocationUpdate(address) {
    try {
        const { basket } = yield select()
        const savedBasket = basket.toJS()
        const basketItems = savedBasket.basketItems
        const shouldShowPreOrder = (!isDeliveryMode() && CommonUtil.checkForPreOrderItems(basketItems))
        yield* getHomePageItems()
        if (isDeliveryMode()) {
            yield put(getAlcoholRestriction(address))
        } else {
            yield put(setAlcoholRestriction(null))
        }

        // TO DO :Need to add the check for alcohol restricted items for Alcohol restricted address
        yield* updateShipping()
        if(shouldShowPreOrder){
            yield* getCart()
        }
    } catch (error) {
        console.log(' Error in triggerAllAPIsForLocationUpdate ', error)
    }
}

function* globalAssortmentChanged() {
    try {
        yield put(getConfiguration())
        yield* getPickupStores()
        yield* getHomePageItems()
    } catch (error) {
        console.log(' Error in fetching global assortment for a specific country ', error)
    }
}

export function* getPickupStores(action) {
    try {
        const { location, user } = yield select()
        const country = action.queryCountry
            ? action.queryCountry
            : getCurrentCountry(location, user)
            const getStoresURL = `${pickupStoresURL}?features=pickup&training_mode=false&country=${country}`
            const response = yield call(api, getStoresURL, 'GET')    

        const { stores, error } = response
        if (stores) {
            const parsedStoreList = []
            stores.forEach(item => {
                if (item.lat && item.lon) {
                    item.location = { latitude: item.lat, longitude: item.lon }
                    parsedStoreList.push(item)
                }
            })
            yield put(pickupStoresSuccess(parsedStoreList))
        } else {
            yield put(pickupStoresFailed(error))
        }
    } catch (error) {
        yield put(pickupStoresFailed(error))
    }
}

export function* fetchStoreDetails(action) {
    try {
        const { user, appSettings, basket } = yield select()
        const profile = user.get('userProfile')
        const trainingMode = (profile && profile.get('training_mode')) || false
        const { store_id } = action.payload
        const isCateringMode = appSettings.get('isCateringMode') || basket.get('hasPlatterItems')

        const getStoresURL = `${pickupStoresURL}?store_id=${store_id}&training_mode=${trainingMode}`
        const response = yield call(api, getStoresURL, 'GET')
        if (!action.countryChange) {
            if (response && response.store_id) {
                yield put(getStoreDetailsSuccess(response))
                const storeAddress = util.getCommonFormattedAddress(response, orderTypes.PICKUP)
                if (isCateringMode) {
                    yield put(saveCateringAddress(storeAddress, response))
                } else {
                    yield put(setAddress(storeAddress))
                    yield put(setStoreDetails(response))
                    yield* triggerAllAPIsForLocationUpdate(storeAddress)
                }
            } else {
                yield put(getStoreDetailsFailed(response))
            }
        }
    } catch (error) {
        yield put(getStoreDetailsFailed(error))
    }
}

function* transferAllTempDetails() {
    const { location } = yield select()
    const selectedAddress = location.get('selectedTempAddress')
    const address = selectedAddress?.toJS()
    if (!address) {
        return
    }
    yield put(transferTempToSelected())
    yield* triggerAllAPIsForLocationUpdate(address)
}

function* filterPickupStores({ payload }) {
    const { location, configuration } = yield select()
    const stores = location.get('pickupStores')
    const placeDetails = payload
    const storesRadiusCheck = configuration.get('pickup_radius')

    if (placeDetails) {
        const user_state = placeDetails.state
        const user_latitude = placeDetails.lattitude
        const user_longitude = placeDetails.longitude

        const storesNearUser = []
        const storesInUserState = stores.filter(store => store.state === user_state)

        // get all stores that are in a 10 miles radius
        if (storesInUserState.length) {
            for (let i = 0; i < storesInUserState.length; i++) {
                const distanceFromUserToStore = CommonUtil.calculateDistance(
                    { coordinate: { latitude: user_latitude, longitude: user_longitude } },
                    {
                        coordinate: {
                            latitude: storesInUserState[i].location.latitude,
                            longitude: storesInUserState[i].location.longitude,
                        },
                    }
                )

                if (distanceFromUserToStore <= (storesRadiusCheck || 10)) {
                    storesNearUser.push({
                        ...storesInUserState[i],
                        distance: distanceFromUserToStore,
                        street: payload?.street,
                    })
                }
            }
        }

        yield put(
            filterStoreComplete(storesNearUser.sort((a, b) => (a.distance > b.distance ? 1 : -1)))
        )
    }
}

function* filterPickupWatcher() {
    yield takeLatest(actions.FILTER_STORES_BY_STATE, filterPickupStores)
}
function* globalAssortmentWatcher() {
    yield takeLatest(actions.SET_COUNTRY_FOR_GLOBAL_ASSORTMENT, globalAssortmentChanged)
}

function* getStoresWatcher() {
    yield takeLatest(actions.GET_STORES_BY_LOCATION, getStoresList)
}

function* getPickupStoresWatcher() {
    yield takeLatest(actions.GET_PICKUP_STORES, getPickupStores)
}

function* alcoholRestrictionWatcher() {
    yield takeLatest(actions.GET_ALCOHOL_RESTRICTIONS, alcoholRestrictions)
}

function* validateUSPSWatcher() {
    yield takeLatest(actions.VALIDATE_USPS, validateUSPS)
}

function* detailsFromCoordinatesWatcher() {
    yield takeLatest(actions.GET_ADDRESS_FROM_COORDINATES, coordinatesWrapper)
}

function* getStoreDetailsWatcher() {
    yield takeLatest(actions.GET_STORE_DETAILS, fetchStoreDetails)
}

function* detailsFromPlaceIdWatcher() {
    yield takeLatest(actions.GET_PLACE_DETAILS, placeIdWrapper)
}

function* transferAllTempDetailsWatcher() {
    yield takeLatest(actions.TRANSFER_ALL_TEMP, transferAllTempDetails)
}

export default function* locationSaga() {
    yield all([
        detailsFromPlaceIdWatcher(),
        detailsFromCoordinatesWatcher(),
        alcoholRestrictionWatcher(),
        validateUSPSWatcher(),
        getStoresWatcher(),
        getPickupStoresWatcher(),
        filterPickupWatcher(),
        getStoreDetailsWatcher(),
        transferAllTempDetailsWatcher(),
        globalAssortmentWatcher(),
    ])
}
